/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { Table } from './table';
var Database;

(function (Database) {
  function ofTables(name, schema, tables) {
    var keys = Object.keys(tables);
    var ret = Object.create(null);
    var tableNames = [];
    ret._name = name;
    ret._tableNames = tableNames;
    ret._schema = schema;

    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
      var k = keys_1[_i];
      if (!Table.is(tables[k])) continue;
      ret[k] = tables[k];
      tableNames[tableNames.length] = k;
    }

    return ret;
  }

  Database.ofTables = ofTables;

  function getTablesAsRows(database) {
    var ret = {};

    for (var _i = 0, _a = database._tableNames; _i < _a.length; _i++) {
      var k = _a[_i];
      ret[k] = Table.getRows(database[k]);
    }

    return ret;
  }

  Database.getTablesAsRows = getTablesAsRows;
})(Database || (Database = {}));

export { Database };